import { Bell, Clock, Globe, Lock, Mail, Shield, Webhook } from 'lucide-react'
import { FREE_PLAN, formatIntervalMinutes } from '../../content/planMarketing'
import { PRICING_FEATURE_FOOTNOTE } from '../../content/pricingFeatures'
import { LandingSection } from './LandingSection'

const features = [
  {
    icon: Bell,
    title: 'Slack alerts',
    description: 'Downtime notifications land in the channels your team already watches.',
  },
  {
    icon: Mail,
    title: 'Email alerts',
    description: 'Add email recipients to escalation policies so the right people get notified.',
  },
  {
    icon: Globe,
    title: 'Public status pages',
    description: 'Share uptime with customers on a branded page with charts and monitor status.',
  },
  {
    icon: Lock,
    title: 'SSL & domain expiry',
    description: 'Get alerts before certificates or domain registrations expire.',
  },
  {
    icon: Shield,
    title: 'Escalation policies',
    description: 'Define who gets alerted, recheck intervals, and high-priority escalation.',
  },
  {
    icon: Webhook,
    title: 'GET and POST checks',
    description: 'Monitor APIs, webhooks, and health endpoints—not just homepages.',
  },
  {
    icon: Globe,
    title: 'Realistic requests',
    description: 'Browser-like user agents and custom headers for strict WAF rules.',
  },
  {
    icon: Clock,
    title: 'Scheduled checks',
    description: `${formatIntervalMinutes(FREE_PLAN.intervalMinutes)} on the free plan. Pro and Max offer faster checks.`,
  },
]

export function LandingFeatures() {
  return (
    <LandingSection
      id="features"
      title="Alerts, status pages, and realistic checks"
      subtitle="Everything you need to catch outages and expiring certificates early—without noisy false positives."
    >
      <ul className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {features.map((feature) => (
          <li
            key={feature.title}
            className="rounded-xl border border-border-subtle bg-surface/30 p-5"
          >
            <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent/15">
              <feature.icon className="h-4 w-4 text-accent" aria-hidden />
            </div>
            <h3 className="mt-3 font-semibold text-text-primary">{feature.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-text-secondary">{feature.description}</p>
          </li>
        ))}
      </ul>
      <p className="mt-8 text-sm text-text-muted">{PRICING_FEATURE_FOOTNOTE}</p>
    </LandingSection>
  )
}
